import { render, staticRenderFns } from "./analytics.page.vue?vue&type=template&id=56282445&scoped=true&"
import script from "./analytics.page.vue?vue&type=script&lang=js&"
export * from "./analytics.page.vue?vue&type=script&lang=js&"
import style0 from "./analytics.page.vue?vue&type=style&index=0&id=56282445&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56282445",
  null
  
)

export default component.exports